import React, { useEffect, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import "./schoolStorage.css";
import CurrentVideo from "./AllStorageVideo/CurrentVideo";
import DeletedVideo from "./AllStorageVideo/DeletedVideo";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import userService from "../../../services/user.service";
import { getFromLocalStorage } from "../../../utils/webStorage";
import { useSelector } from "react-redux";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import { Paper } from "@material-ui/core";
import PageNotFoundPage from "../../../Common/PageNotFoundPage";
import { permissionNames } from "../../../utils/constant";

const SchoolAdminStorage = () => {
  const schoolId = useSelector((state) => state.loggedInUser.school.id);
  const [videoStatus, setVideoStatus] = useState("current");
  const [purchasedHours, setPurchasedHours] = useState("");
  const [totalDuration, setTotalDuration] = useState();
  const [usedDuration, setUsedDuration] = useState();
  const [percentage, setPercentage] = useState();
  const [assignedRights, setAssignedRights] = useState([]);
  const adminRole = getFromLocalStorage("loginRole");
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );

  const handleChange = (e) => {
    setVideoStatus(e);
  };

  useEffect(() => {
    const assignedRights = JSON.parse(
      getFromLocalStorage("assignedRights") || []
    );
    const assignedRightsIds = assignedRights.map((item) => item.displayName);
    setAssignedRights(assignedRightsIds);
    if (
      adminRole == "SCHOOL ADMIN" ||
      assignedRightsIds?.includes(permissionNames?.View_Data_Usage)
    ) {
      getStorageDetails();
    }
  }, []);

  useEffect(() => {
    adminRole == "SCHOOL ADMIN" ||
    assignedRights?.includes(permissionNames?.View_Data_Usage)
      ? setVideoStatus("current")
      : setVideoStatus("delete");
  }, [assignedRights]);

  const getStorageDetails = () => {
    userService
      .getAllSportsHoursDetails(schoolId)
      .then((res) => {
        const { usedHours, totalHoursPurchased } = res.data.data;
        let per = (usedHours / 18000) * 100;
        setPercentage(per.toFixed(3));
        setPurchasedHours(totalHoursPurchased);
        setTotalDuration(totalHoursPurchased);
        setUsedDuration(usedHours.toFixed(2));
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const checkDataUsagePermission = () => {
    return (
      videoStatus === "current" &&
      (adminRole == "SCHOOL ADMIN" ||
        assignedRights?.includes(permissionNames?.View_Data_Usage))
    );
  };

  return (
    <>
      {adminRole == "SCHOOL ADMIN" ||
      assignedRights.includes("Add / Remove Video Content") ? (
        <>
          <SchoolAdminDashboard />
          <div
            className={
              isDrawerOpen ? "content-layout" : "toggle-content-layout"
            }
          >
            <div className="storage-management-main-container">
              <div className="left">
                <div className="d-flex flex-direction-c height-full">
                  {(adminRole == "SCHOOL ADMIN" ||
                    assignedRights?.includes(
                      permissionNames?.View_Data_Usage
                    )) && (
                    <Paper className="flex-1">
                      <h4 className="storage-title bold">Storage Hours</h4>
                      <div className="px-3 pt-3 check-box">
                        <FormControl className="fmlabel" id="checkbtn">
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            defaultValue="current"
                          >
                            <FormControlLabel
                              className=""
                              onClick={() => handleChange("current")}
                              value="current"
                              control={<Radio />}
                              label="Storage Graph"
                              checked={videoStatus === "current"}
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                      <div>
                        <div className="storage-hours2">
                          <p className="fs-20 pb-3 bold">
                            {" "}
                            {usedDuration > 0 ? usedDuration : 0}
                            {" Hours"}
                            <span className="text-secondary fw-bold fs-18">
                              {" "}
                              of {purchasedHours} hours (
                              {percentage > 0 ? percentage : 0}
                              %) used{" "}
                            </span>
                          </p>

                          <div className="progress ">
                            <div
                              className="bg-warning"
                              role="progressbar"
                              style={{ width: `${percentage}%` }}
                              aria-valuenow="75"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                          <p className="text-warning fs-16 pt-3">
                            <RiErrorWarningFill className="text-warning fs-24 mr-2" />
                            Delete video to free up space
                          </p>
                        </div>
                      </div>
                    </Paper>
                  )}

                  <Paper className="mg-top-10 flex-1">
                    <h4 className="storage-title bold">Video Management</h4>
                    <div className="px-3 pt-3 check-box">
                      <FormControl className="fmlabel" id="checkbtn">
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          name="radio-buttons-group"
                        >
                          <FormControlLabel
                            onClick={() => handleChange("delete")}
                            value="delete"
                            control={<Radio />}
                            label="Manage Deleted Video"
                            checked={videoStatus === "delete"}
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </Paper>
                </div>
              </div>
              <div style={{ width: "100%" }}>
                {checkDataUsagePermission() && (
                  <div className="manage-event">
                    <CurrentVideo getStorageDetails={getStorageDetails} />
                  </div>
                )}

                {videoStatus === "delete" && (
                  <div className="manage-event">
                    <DeletedVideo getStorageDetails={getStorageDetails} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <PageNotFoundPage />
      )}
    </>
  );
};

export default SchoolAdminStorage;
